<permission-checker [roles]="roles" (contentInit)="initContent()" (rolesLoaded)="handleRolesLoaded($event)">
  <div class="content-holder">
    <school-select [roles]="roles"
                   [showGrade]="false"
                   [clearSchoolAfterSelect]="false"
                   [allowSchoolClear]="true"
                   (regionSelected)="regionSelected($event)"
                   (schoolSelected)="schoolSelected($event)"></school-select>

    <mat-spinner *ngIf="inProgress" color="primary" diameter="40" class="center"></mat-spinner>

    <school-details *ngIf="!inProgress && school"
                    [school]="school"
                    [mobile]="mobileView"></school-details>

    <div class="center-align full-width controls">
      <div *ngIf="school;else noSchoolSelected">
        <app-button *ngIf="deleteAllowed && school"
                    icon="delete"
                    matTooltip="Delete"
                    i18n-matTooltip="General|Delete action label@@general-delete-action-label"
                    [destructive]="true"
                    (clicked)="deleteSchool(school)"></app-button>
        <span *ngIf="deleteAllowed" class="btn-spacer"></span>

        <app-button label="Edit"
                    i18n-label="General|Edit action label@@general-edit-action-label"
                    color="primary"
                    (clicked)="editSchool(school)"></app-button>
      </div>
      <ng-template #noSchoolSelected>
        <mat-divider class="full-width divider"></mat-divider>
        <app-button label="Create"
                    i18n-label="General|Create action label@@general-create-action-label"
                    color="primary"
                    (clicked)="addSchool()"></app-button>
      </ng-template>
    </div>
  </div>
</permission-checker>
